module.exports = __webpack_public_path__ + "static/media/drone.dc0bb817.jpg";